<h3 class="text-dark font-16 font-md-18 font-mx-60 mt-1">
  {{ 'consent_privacy_and_data_protection_title' | translate }}
  <br />
  {{ 'consent_privacy_and_data_protection_title_info' | translate }}
</h3>
<ol class="text-justify list-none pl-0 mt-5">
  <li>
    <ol class="list-none pl-0">
      <li>
        <h6 class="text-dark font-14 font-md-16 mt-5 text-left">
          {{ 'consent_privacy_and_data_protection_subtitle_1' | translate }}
        </h6>
        <p
          class="font-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p1' | translate"
        ></p>
        <p
          class="font-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p2' | translate"
        ></p>
        <p
          class="font-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p3' | translate"
        ></p>
        <p
          class="font-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p4' | translate"
        ></p>
        <p
          class="font-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p5' | translate"
        ></p>
        <p
          class="font-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p6' | translate"
        ></p>
      </li>
      <li>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_info' | translate"
        ></p>
        <ul class="list-none pl-0">
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_1_1_list1' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_1_1_list2' | translate
            }}</span>
          </li>
        </ul>
      </li>
      <li>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_p1' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_p2' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_p3' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_p4' | translate"
        ></p>
      </li>
      <li>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_2' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_2_p1' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_2_p2' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_2_p3' | translate"
        ></p>
      </li>
      <li>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_3' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_3_p1' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_3_p2' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_3_p3' | translate"
        ></p>
      </li>
      <li>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_4' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_4_p1' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_4_p2' | translate"
        ></p>
      </li>

      <li>
        <h6 class="text-dark font-14 font-md-16 mt-5 text-left">
          {{ 'consent_privacy_and_data_protection_subtitle_3' | translate }}
        </h6>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_3_p1' | translate"
        ></p>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_3_p2' | translate"
        ></p>
        <ul class="list-none pl-0">
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_3_list1' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_3_list2' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_3_list3' | translate
            }}</span>
          </li>
        </ul>
      </li>
      <li>
        <h6 class="text-dark font-14 font-md-16 mt-5 text-left">
          {{ 'consent_privacy_and_data_protection_subtitle_4' | translate }}
        </h6>
        <p
          class="font-14 font-md-14"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_4_p1' | translate"
        ></p>
      </li>

      <li>
        <h6 class="text-dark font-14 font-md-16 mt-5 text-left">
          {{ 'consent_privacy_and_data_protection_subtitle_5' | translate }}
        </h6>
        <p
          class="font-14 font-md-14"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_p1' | translate"
        ></p>
        <ul class="list-none pl-0">
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_5_list1' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_5_list2' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_5_list3' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_5_list4' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_5_list5' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_5_list6' | translate
            }}</span>
          </li>
          <li class="d-flex pb-2">
            <span class="pr-2">-</span>
            <span class="font-14 font-md-14 text-left">{{
              'consent_privacy_and_data_protection_paragraph_5_list7' | translate
            }}</span>
          </li>
          <p
            class="font-14 font-md-14 text-left"
            [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_p2' | translate"
          ></p>
        </ul>
      </li>
      <li>
        <h6 class="text-dark font-14 font-md-16 mt-5 text-left">
          {{ 'consent_privacy_and_data_protection_subtitle_6' | translate }}
        </h6>
        <p
          class="font-14 font-md-14 text-left"
          [innerHTML]="'consent_privacy_and_data_protection_paragraph_6_p1' | translate"
        ></p>
      </li>
    </ol>
  </li>
</ol>
